import React from "react";
import "./App.css";
import DataFetcher from "./DataFetcher";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <DataFetcher />
      </header>
    </div>
  );
}

export default App;
